export default {
    slug: 'mileages',
    ability: 'mileages',
    routes: [
        {
            path: 'mileages',
            name: 'mileages',
            component: () => import('@modules/Mileages/Resources/js/pages/Index.vue'),
            redirect: { name: 'mileages-overview' },
            children: [
                {
                    path: 'overview',
                    name: 'mileages-overview',
                    component: () => import('@modules/Mileages/Resources/js/pages/Overview.vue'),
                    props: true
                },
                {
                    path: 'list',
                    name: 'mileages-list',
                    component: () => import('@modules/Mileages/Resources/js/pages/TableList.vue'),
                    props: true
                }
            ]
        }
    ],
    nav: () => ({
        section: 'hr',
        items: [
            {
                title: i18n.t('Mileages'),
                icon: 'car',
                to: { name: 'mileages' }
            }
        ]
    })
};
